export default {
    addNotifNew({commit}, item) {
        commit('ADD_NOTIF_NEW', item)
    },

    changeInitiate({commit}, item) {
        commit('CHANGE_INITIATE', item)
    },
}
